import { history } from "../../../_components/_helpers/history";
import { services, hooks } from "../../../studentportal-sdk";
import { useEffect } from "react";

export const AssessmentHook = (props) => {
  // assessment service instance
  const _assessmentService = services.Assessment(props);
  const _courseService = services.Course(props);

  const role = localStorage.getItem("role")

  const {
    action: { getAllCourse },
  } = _courseService;

  const {
    store: { assessmentAction },
    action: {
      EnrolledAssessment,
      getAllAssessment,
      setAssessmentAction,
      getAllQuestions,
      getQuestion,
    },
    history,
  } = _assessmentService;
  const questions = JSON.parse(localStorage.getItem("questions"));

  useEffect(() => {
    if (["/viewassessment"].includes(history.location.pathname)) {
      role === "user" && getQuestion();
    }
  }, []);

  // useEffect(() => {
  //  const timer = parseInt(localStorage.getItem("timer"))
  //  timer > 0 && window.location.href == "/viewassessment"
  // }, [])


  useEffect(() => {
    if (
      ["/editassessment", "/viewassessment"].includes(history.location.pathname)
    ) {
      return;
    }

    setAssessmentAction({ id: "", action: "" });
    localStorage.removeItem("assessmentId");
    getAllAssessment();
    getAllCourse();
  }, []);

  useEffect(() => {
    const assessmentId = localStorage.getItem("assessmentId");
    // if (assessmentId) getassessmentById(assessmentId);

    if (assessmentAction.action === "view") {
      history.push("/viewassessment");
    } else if (assessmentAction.action === "edit") {
      history.push("/editassessment");
    }
  }, [assessmentAction]);

  useEffect(() => {

    if(["/enrolledassessments"].includes(history.location.pathname)){
        const userId = localStorage.getItem("userId");
        EnrolledAssessment(userId)
    }
    const assessmentId = localStorage.getItem("assessmentId");

    const questionData = {
      assessmentId,
    };

    role ==="admin" && getAllQuestions(questionData);
    
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Empty dependency array, runs only once on mount

  return {
    assessmentService: {
      ..._assessmentService,
    },
    courseService: {
      ..._courseService,
    },
    ...props,
  };
};

export const assessment = (props) =>
  AssessmentHook(hooks.UtilityAndConfig(props));